import React, { useState } from 'react';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Newsletter from './Newsletter';
import Embed from '../Templates/Embed/Embed';
import { translate, prefix } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './Footer.scss';
import './Photoswipe.scss';

const JotFormIframe = `<iframe id="JotFormIFrame-223402333428346" title="Message Form" onload="window.parent.scrollTo(0,0)" allowtransparency="true" allowfullscreen="true" allow="geolocation; microphone; camera" src="https://form.jotform.com/223402333428346" frameborder="0" style=" min-width: 100%; height:539px; border:none;" scrolling="no"     >     </iframe>     <script type="text/javascript"> var ifr = document.getElementById("JotFormIFrame-223402333428346"); if (ifr) {   var src = ifr.src;   var iframeParams = [];   if (window.location.href && window.location.href.indexOf("?") > -1) {     iframeParams = iframeParams.concat(window.location.href.substr(window.location.href.indexOf("?") + 1).split('&'));   }   if (src && src.indexOf("?") > -1) {     iframeParams = iframeParams.concat(src.substr(src.indexOf("?") + 1).split("&"));     src = src.substr(0, src.indexOf("?"))   }   iframeParams.push("isIframeEmbed=1");   ifr.src = src + "?" + iframeParams.join('&'); } window.handleIFrameMessage = function(e) {   if (typeof e.data === 'object') { return; }   var args = e.data.split(":");   if (args.length > 2) { iframe = document.getElementById("JotFormIFrame-" + args[(args.length - 1)]); } else { iframe = document.getElementById("JotFormIFrame"); }   if (!iframe) { return; }   switch (args[0]) {     case "scrollIntoView":       iframe.scrollIntoView();       break;     case "setHeight":       iframe.style.height = args[1] + "px";       break;     case "collapseErrorPage":       if (iframe.clientHeight > window.innerHeight) {   iframe.style.height = window.innerHeight + "px";       }       break;     case "reloadPage":       window.location.reload();       break;     case "loadScript":       if( !window.isPermitted(e.origin, ['jotform.com', 'jotform.pro']) ) { break; }       var src = args[1];       if (args.length > 3) {     src = args[1] + ':' + args[2];       }       var script = document.createElement('script');       script.src = src;       script.type = 'text/javascript';       document.body.appendChild(script);       break;     case "exitFullscreen":       if      (window.document.exitFullscreen)  window.document.exitFullscreen();       else if (window.document.mozCancelFullScreen)   window.document.mozCancelFullScreen();       else if (window.document.mozCancelFullscreen)   window.document.mozCancelFullScreen();       else if (window.document.webkitExitFullscreen)  window.document.webkitExitFullscreen();       else if (window.document.msExitFullscreen)      window.document.msExitFullscreen();       break;   }   var isJotForm = (e.origin.indexOf("jotform") > -1) ? true : false;   if(isJotForm && "contentWindow" in iframe && "postMessage" in iframe.contentWindow) {     var urls = {"docurl":encodeURIComponent(document.URL),"referrer":encodeURIComponent(document.referrer)};     iframe.contentWindow.postMessage(JSON.stringify({"type":"urls","value":urls}), "*");   } }; window.isPermitted = function(originUrl, whitelisted_domains) {   var url = document.createElement('a');   url.href = originUrl;   var hostname = url.hostname;   var result = false;   if( typeof hostname !== 'undefined' ) {     whitelisted_domains.forEach(function(element) {   if( hostname.slice((-1 * element.length - 1)) === '.'.concat(element) ||  hostname === element ) {       result = true;   }     });     return result;   } }; if (window.addEventListener) {   window.addEventListener("message", handleIFrameMessage, false); } else if (window.attachEvent) {   window.attachEvent("onmessage", handleIFrameMessage); } </script>`;


const Footer = ({ properties, setup, footer, navigation }) => {
	if (properties.siteInitiated === false || properties.siteClosed === true) return null;
	const [accordianIndex, toggleAccordianMenus] = useState('#contact-toggle');
	const [loadForm, toggleForm] = useState(false);
	const [showForm, toggleFormVisiblity] = useState(false);

	const accordianHandler = (e) => {
		e.preventDefault();
		const href = e.currentTarget.getAttribute('href');
		if (accordianIndex === href) {
			toggleAccordianMenus(null);
		} else {
			toggleAccordianMenus(href);
		}
	};

	const toggleFormHandler = () => {
		if (!loadForm) toggleForm(true);
		toggleFormVisiblity((prevState) => !prevState);
	};

	return (
		<footer className={s.footer}>
			<div className={s.footer_chat}>
				<button className={[s.footer_chat_toggle, showForm ? s.footer_chat_toggle__showing : null].join(' ')} type="button" aria-label="Emeco contact form" onClick={toggleFormHandler}>
					<svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55"><path fill="none" stroke="#000" d="M17.8808309,0 C18.8383631,0 19.705341,0.389229984 20.3328733,1.01882549 C20.9596308,1.64764344 21.3474733,2.51629581 21.3474733,3.47589129 L21.3474733,11.6130749 L23,18 L16.6191625,16.3322659 L3.46664233,16.3322659 C2.50911019,16.3322659 1.64213226,15.9430359 1.01459992,15.3134403 C0.387842509,14.6846224 0,13.8159701 0,12.8563746 L0,3.47589129 C0,2.51629581 0.387842509,1.64764344 1.01459992,1.01882549 C1.64213226,0.389229984 2.50911019,0 3.46664233,0 L17.8808309,0 Z" transform="translate(16 18)" /></svg>
				</button>
				<div className={[s.footer_chat_content, showForm ? s.footer_chat_content__showing : null].join(' ')}>
					<p className={s.footer_chat_content_intro}>{ translate(setup, 'chatText') }</p>
					{ loadForm && <Embed content={{ rawText: JotFormIframe }} /> }
				</div>
			</div>
			<Newsletter />
			<nav className={s.footer_items}>
				{
					navigation?.header && [...navigation.header, ...(navigation?.support ? navigation.support : [])].map((level1) => {
						const level1Link = prefix(setup, translate(setup, level1, 'uri'));

						return (
							<div className={s.footer_item}>
								<Link className={[s.footer_item_link, (level1?.subPages ? s.footer_item_link__expandable : null)].join(' ')} to={level1Link} onClick={level1?.subPages ? accordianHandler : null}>
									{ translate(setup, level1, 'title') }
									{
										level1?.subPages && (
											<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
												{ accordianIndex !== level1Link && <line x1="10.0234" y1="2.08149e-08" x2="10.0234" y2="20" stroke="black" /> }
												<line x1="20" y1="10.5" x2="-4.37114e-08" y2="10.5" stroke="black" />
											</svg>
										)
									}
								</Link>
								{
									accordianIndex === level1Link && level1?.subPages && (
										<div className={s.footer_item_subLinks}>
											{
												level1.subPages.map((level2) => (
													<Link className={s.footer_item_subLink} to={prefix(setup, translate(setup, level2, 'uri'))}>{ translate(setup, level2, 'title') }</Link>
												))
											}
										</div>
									)
								}
							</div>
						);
					})
				}
				<div className={s.footer_socialLinks}>
					{
						footer.socialMediaIcons && footer.socialMediaIcons.map((item) => {
							if (item.link.indexOf(/(http|mailto|tel)/) === -1) {
								return <a className={s.footer_socialLink} href={item.link} key={urlify(item.icon.url)} target="_blank" rel="noopener noreferrer nofollow"><img className={s.footer_socialLink_icon} src={item.icon.url} alt={item.icon.alt} /></a>;
							}
							return <Link className={s.footer_socialLink} to={prefix(setup, item.link)} key={urlify(item.icon.url)} rel="nofollow"><img className={s.footer_socialLink_icon} src={item.icon.url} alt={item.icon.alt} /></Link>;
						})
					}
				</div>
			</nav>
		</footer>
	);
};

const mapState = ({ environment }) => {
	const { properties, setup, footer, navigation } = environment;
	return { properties, setup, footer, navigation };
};

export default connect(mapState)(Footer);
